class BannerCarousel extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('DOMContentLoaded', () => {
      this.initSwiper();
    });
  }

  initSwiper() {
    new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1,
      effect: 'fade',
      crossFade: true,
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true
      },
      navigation: {
        nextEl: '.swiper-button-custom-next',
        prevEl: '.swiper-button-custom-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}

customElements.define('banner-carousel', BannerCarousel);
